import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Text } from "../../components/Text";

export const GoogleDriveWindowCallback: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      window.close();
      return;
    }

    if (!code) {
      navigate("/");
      return;
    }

    if (window.opener) {
      window.opener.postMessage(
        { type: "GOOGLE_DRIVE_CONNECT_SUCCESS", code },
        window.location.origin,
      );
      window.close();
    }
  }, [navigate]);

  return <Text>{t("common.authenticating")}</Text>;
};
